import { render, staticRenderFns } from "./ClienteShowData.vue?vue&type=template&id=2850f630&scoped=true&"
import script from "./ClienteShowData.vue?vue&type=script&lang=js&"
export * from "./ClienteShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850f630",
  null
  
)

export default component.exports